import { TextField } from "@fluentui/react/lib/TextField";
import React, { useEffect } from "react";

import { useSearchBar } from "./SearchBarHook";
import { formatMessage } from "../../../utils/helpers/LanguageHelper";

interface SearchBarProps {
  onSearch: (query: string) => void;
  currentQuery?: string;
  searchTrigger?: "change" | "enter";
  variant?: "default" | "compact";
  transform?: (query: string) => string;
}
export const SearchBar: React.FunctionComponent<SearchBarProps> = ({
  onSearch,
  currentQuery = undefined,
  searchTrigger = "change",
  variant = "default",
  transform = (query: string) => query.trim().toLowerCase(),
}) => {
  const { classNames, onRenderInputWrapper } = useSearchBar(variant);
  const [currentValue, setCurrentValue] = React.useState(currentQuery);

  useEffect(() => {
    setCurrentValue(currentQuery);
  }, [currentQuery]);

  return (
    <div className={`ms-Grid ${classNames.container}`}>
      <div className="ms-Grid-row">
        <div className="ms-Grid-col ms-sm12 ms-md12 ms-lg12">
          <div className={classNames.formField}>
            <TextField
              id="search_edit"
              borderless
              value={currentValue}
              onRenderInput={onRenderInputWrapper(variant)}
              className={classNames.searchBar}
              placeholder={formatMessage("cof.base.searchbar") + (variant === "default" ? "" : "...")}
              onChange={(e) => {
                if (currentQuery !== undefined) {
                  setCurrentValue(e.currentTarget.value);
                }
                if (searchTrigger === "change") {
                  onSearch(transform(e.currentTarget.value));
                }
              }}
              styles={{
                fieldGroup: {
                  height: variant === "default" ? "32px" : "24px",
                },
                field: {
                  "&::placeholder": {
                    color: variant === "compact" ? "#c8c8c8" : "auto",
                  },
                },
              }}
              onKeyDown={
                searchTrigger === "enter"
                  ? (e) => {
                      if (e.key === "Enter") {
                        onSearch(transform(e.currentTarget.value));
                      }
                    }
                  : undefined
              }
            />
          </div>
        </div>
      </div>
    </div>
  );
};
